<template>
    <v-dialog :value="$store.getters['admin/manageNoteDialog']" persistent width="40%">
        <v-card>
            <v-card-title>Manage Note</v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-text-field v-model.trim="note.name" :rules="requiredRules" label="Name" required />
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="saveNote">Save Note</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {NotesHttp} from "../../../http/notes";
    import {EventBus} from "../../../EventBus";

    export default {
        name: "ManageNoteDialog",
        data() {
            return {
                isLoading: false,
                note: {},
                requiredRules: [
                    v => !!v || 'This field is required'
                ],
                valid: true
            }
        },
        methods: {
            async saveNote() {
                if (this.$refs.form.validate()) {
                    this.isLoading = true;
                    try {
                        await NotesHttp.createNote(this.note);
                        EventBus.$emit('message', {message: 'Note Saved Successfully', type: 'success'});
                        this.closeDialog();
                    } catch (e) {
                        EventBus.$emit('message', {message: e, type: 'error'});
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            async closeDialog() {
                await this.$store.dispatch('admin/setNotes');
                await this.$store.dispatch('admin/setManageNoteDialog', false);
            }
        }
    }
</script>

<style scoped>

</style>
